import { defineComponent } from "vue";
export default defineComponent({
  name: "ToolboxOverlay",
  emits: ["close"],
  mounted() {
    document.addEventListener("keydown", this.onKeydown);
  },
  beforeUnmount() {
    document.removeEventListener("keydown", this.onKeydown);
  },
  methods: {
    onKeydown(e) {
      if (e.key === "Escape") this.$emit("close");
    }
  }
});